import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import SliderField from 'components/SliderField';

import { TEST_ID } from './constants';
import type { FunctionComponent, NumericChangeParams, Props } from './types';

import styles from './styles.module.scss';

const SliderFieldRow: FunctionComponent<Props> = ({
    className = '',
    disabled = false,
    label,
    max,
    maxLabel,
    min,
    minLabel,
    onChange,
    step,
    testId = TEST_ID,
    unit,
    value
}) => {
    const handleChange = ({ value: nextValue }: NumericChangeParams) => {
        onChange(nextValue);
    };

    return (
        <VerticalContainer className={`${styles.sliderFieldRow} ${className}`} testId={testId}>
            <SliderField
                disabled={disabled}
                label={label}
                max={max}
                min={min}
                onChange={handleChange}
                step={step}
                unit={unit}
                value={value}
            />

            <HorizontalContainer className={styles.rangeRow}>
                <Wrapper className={styles.rangeMin}>{minLabel}</Wrapper>

                <Wrapper className={styles.rangeMax}>{maxLabel}</Wrapper>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default SliderFieldRow;
